const config = {
    //PRODUDCTION
    BaseUrl: 'https://quotecompare.wcaoem.com',
    //DEVELOPMENT
    // BaseUrl: 'http://localhost:8000',
  };
  
export default config;